// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1zTE1","approved":"Status_approved__3KtGi","rejected":"Status_rejected__32OX2","expired":"Status_expired__OrhUi","label":"Status_label__1hfxE"};